import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseWeightClinical = z.object({
    wnl: z.boolean().optional(),
    currentHeight: z.string().optional(),
    currentWeight: z.string().optional(),
    heightSource: z.string().optional(),
    weightSource: z.string().optional(),
    previousWeight: z.string().optional(),
    previousWeightDate: z.string().optional(),
    previousWeightSource: z.string().optional(),
    weightChange: z.string().optional(),
    weightChangeAmount: z.string().optional(),
    weightChangePeriod: z.string().optional(),
    weightChangePeriodOther: z.string().optional(),
    changeIntentional: z.string().optional(),
    weightLossCauses: z.array(z.string()).optional(),
    weightGainCauses: z.array(z.string()).optional(),
    weightGainSymptoms: z.array(z.string()).optional(),
    monitoringReasons: z.array(z.string()).optional(),
    clinicalNarrative: z.string().optional(),
});
export const weightClinicalHasValue = (data) => {
    const { currentHeight, currentWeight, ...clinicalValues } = data;
    return sectionHasValue(clinicalValues);
};
export const baseWeightClinicalRefined = baseWeightClinical.refine((data) => weightClinicalHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
export const baseOralIntakeClinical = z.object({
    wnl: z.boolean().optional(),
    appetite: z
        .object({
        currentAppetite: z.string().optional(),
        appetiteChange: z.string().optional(),
        appetiteChangeSince: z.string().optional(),
        appetiteChangeCause: z.string().optional(),
        mealsPerDay: z.string().optional(),
        typicalIntake: z.string().optional(),
        fluidIntake: z.string().optional(),
    })
        .optional(),
    swallowing: z
        .object({
        swallowingDifficulty: z.array(z.string()).optional(),
        aspirationRiskSigns: z.array(z.string()).optional(),
        aspirationPneumoniaHistory: z.string().optional(),
        aspirationPneumoniaWhen: z.string().optional(),
        aspirationPneumoniaEpisodes: z.string().optional(),
        slpEvaluation: z.string().optional(),
        slpEvaluationDate: z.string().optional(),
    })
        .optional(),
    factorsAffecting: z
        .object({
        physical: z.array(z.string()).optional(),
        sensory: z.array(z.string()).optional(),
        cognitivePsych: z.array(z.string()).optional(),
        functional: z.array(z.string()).optional(),
        medicationsAffecting: z.string().optional(),
        medicationsAffectingDetails: z.string().optional(),
        socialEconomic: z.array(z.string()).optional(),
    })
        .optional(),
});
export const baseEatingSupport = z.object({
    wnl: z.boolean().optional(),
    adaptiveEquipment: z
        .object({
        equipmentInUse: z.array(z.string()).optional(),
        equipmentInUseOther: z.string().optional(),
        equipmentNeeded: z.array(z.string()).optional(),
        equipmentNeededList: z.string().optional(),
    })
        .optional(),
    mealAssistance: z
        .object({
        assistanceProvider: z.array(z.string()).optional(),
        helpType: z.array(z.string()).optional(),
        caregiverTrainingNeeded: z.string().optional(),
        caregiverTrainingTopics: z.array(z.string()).optional(),
        caregiverTrainingOther: z.string().optional(),
    })
        .optional(),
});
export const basePocNutrition = z.object({
    skilledJustification: z.array(z.string()).optional(),
});
export const baseK0520Clinical = z.object({
    wnl: z.boolean().optional(),
    parenteral: z
        .object({
        type: z.array(z.string()).optional(),
        access: z.array(z.string()).optional(),
        formula: z.string().optional(),
        rate: z.string().optional(),
        hoursPerDay: z.string().optional(),
        caloriesPerDay: z.string().optional(),
        monitoring: z.array(z.string()).optional(),
        monitoringFrequency: z.string().optional(),
        complications: z.array(z.string()).optional(),
    })
        .optional(),
    feedingTube: z
        .object({
        tubeType: z.array(z.string()).optional(),
        size: z.string().optional(),
        placedDate: z.string().optional(),
        formula: z.string().optional(),
        rate: z.string().optional(),
        method: z.array(z.string()).optional(),
        schedule: z.string().optional(),
        totalVolumePerDay: z.string().optional(),
        freeWaterFlushes: z.string().optional(),
        tubeSite: z.array(z.string()).optional(),
        residuals: z.string().optional(),
        residualThreshold: z.string().optional(),
        residualAction: z.array(z.string()).optional(),
        patientCompetency: z.string().optional(),
        skilledJustification: z.array(z.string()).optional(),
    })
        .optional(),
    mechanicallyAlteredDiet: z
        .object({
        foodTexture: z.array(z.string()).optional(),
        liquidConsistency: z.array(z.string()).optional(),
        reason: z.array(z.string()).optional(),
        reasonOther: z.string().optional(),
        swallowEval: z.string().optional(),
        swallowEvalDate: z.string().optional(),
        dietCompliance: z.string().optional(),
    })
        .optional(),
    therapeuticDiet: z
        .object({
        dietTypes: z.array(z.string()).optional(),
        carbsPerMeal: z.string().optional(),
        sodiumPerDay: z.string().optional(),
        fluidRestriction: z.string().optional(),
        dietTypeOther: z.string().optional(),
        prescribedBy: z.array(z.string()).optional(),
        educationProvided: z.string().optional(),
        educationDate: z.string().optional(),
        dietCompliance: z.string().optional(),
        complianceBarriers: z.array(z.string()).optional(),
        skilledJustification: z.array(z.string()).optional(),
    })
        .optional(),
});
